import type { IconType } from '@kk/ui/components/Icon';
import { cn } from 'cn';
import { MenuContent } from '@/components/SideNavigation/elements/MenuContent';

export type SideNavigationLink = {
  icon: IconType;
  title: string;
  to: string;
  disabled?: boolean;
};

export type SideNavigationProps = {
  links?: SideNavigationLink[];
};

export function SideNavigation({ links }: SideNavigationProps) {
  if (!links || links.length === 0) return null;

  return (
    <div
      id="side-navigation"
      className="text-blue-60 group relative h-screen w-22 space-y-4 overflow-visible"
    >
      <div
        className={cn(
          'bg-blue-5 absolute inset-0 z-30 size-full overflow-hidden px-4 pt-4 transition-[width]',
          'focus-within:shadow-lg-dl-blue group-focus-within:w-64',
          'group-hover:shadow-lg-dl-blue group-hover:w-64',
        )}
      >
        <MenuContent links={links} />
      </div>

      <div className="hidden w-22 group-focus-within:block group-hover:block" />
    </div>
  );
}

export default SideNavigation;
